// components/Mission.js
import React from 'react';
import './Mission.css';

const Mission = () => {
  return (
    <section id="mission" className="mission-section fade-in-section">
      <div className="container">
        <div className="mission-grid">
          <div className="mission-card">
            <div className="mission-icon">🎯</div>
            <h3 className="mission-title">Our Mission</h3>
            <p className="mission-text">
              To deliver verified, high-intent leads to businesses using the power of AI and 
              human intelligence, while ensuring affordability and transparency.
            </p>
          </div>
          
          <div className="mission-card">
            <div className="mission-icon">🔮</div>
            <h3 className="mission-title">Our Vision</h3>
            <p className="mission-text">
              To become India's #1 lead generation platform for real estate, education, healthcare, 
              and local businesses by 2026, making high-quality customer acquisition accessible for all.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;